import React, { FC, useState } from "react";
import {
    faChevronDown,
    faChevronUp,
    faLock,
    faLockOpen,
    faTrashAlt
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    Card,
    Collapse,
    FormControl,
    InputGroup,
    Row,
    Col
} from "react-bootstrap";
import {
    AnalyticsEventDataSchema,
    AnalyticsEventSchema
} from "../../../models/types";
import { AnalyticsEventDataLibraryItem } from "../../variationItems/analytics/AnalyticsEventDataLibraryItem";
import cx from "classnames";

interface Props {
    organizationName: string;
    event: AnalyticsEventSchema;
    applyLibEventUpdate: (eventId: number, frozen: boolean) => void;
    removeLibEvent: (eventId: number) => void;
}

export const AdminAnalyticsEventLibraryItemImplementation: FC<Props> = ({
    organizationName,
    event,
    applyLibEventUpdate,
    removeLibEvent
}) => {
    const [showEventData, updateShowEventData] = useState(false);

    const eventData = event.eventData.map(
        (eventData: AnalyticsEventDataSchema, index: number) => (
            <AnalyticsEventDataLibraryItem
                frozen={true}
                index={index}
                key={index}
                defaultValue={eventData}
                updateAnalyticsDataSchema={() =>
                    console.log("[DEBUG] Nothing should happen")
                }
            />
        )
    );

    return (
        <Card className={cx("m-1", { "border border-primary": event.frozen })}>
            <Card.Header
                onClick={() => {
                    updateShowEventData(!showEventData);
                }}
            >
                <Row className="d-flex text-contrast justify-content-end align-items-center">
                    <Col className="col-1 d-flex align-items-center">
                        {event.organization || organizationName === "Seepia" ? (
                            <FontAwesomeIcon
                                className="mouseHover text-primary"
                                title={
                                    event.frozen
                                        ? "Unfreeze event"
                                        : "Freeze event"
                                }
                                icon={event.frozen ? faLock : faLockOpen}
                                onClick={e => {
                                    if (
                                        event.organization ||
                                        organizationName === "Seepia"
                                    ) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        applyLibEventUpdate(
                                            event.id,
                                            !event.frozen
                                        );
                                    }
                                }}
                            />
                        ) : (
                            <FontAwesomeIcon
                                className="text-secondary"
                                title="Event frozen by Seepia admin"
                                icon={faLock}
                            />
                        )}
                    </Col>
                    <Col className="col-9 d-flex align-items-center">
                        <InputGroup className="m-0 p-0">
                            <InputGroup.Text>EventName</InputGroup.Text>
                            <FormControl
                                className="pe-5"
                                value={event.eventName}
                                readOnly={true}
                                onClick={(e: React.MouseEvent<HTMLElement>) => {
                                    e.stopPropagation();
                                }}
                            />
                        </InputGroup>
                        <div className="ps-2">
                            <FontAwesomeIcon
                                icon={
                                    showEventData ? faChevronUp : faChevronDown
                                }
                                size="1x"
                                className="ps-2 mouseHover"
                            />
                        </div>
                    </Col>
                    <Col className="col-2 d-flex align-items-center justify-content-end">
                        {!event.frozen
                            ? (event.organization ||
                                  organizationName === "Seepia") && (
                                  <FontAwesomeIcon
                                      icon={faTrashAlt}
                                      title="Delete event"
                                      className="text-primary mouseHover"
                                      onClick={() => removeLibEvent(event.id)}
                                  />
                              )
                            : null}
                    </Col>
                </Row>
            </Card.Header>
            <Collapse in={showEventData}>
                <div>
                    <Card.Body>
                        {eventData}
                        <Card className="m-1 p-2 no-border d-flex justify-content-end align-items-center">
                            <InputGroup>
                                <InputGroup.Text>Comment</InputGroup.Text>
                                <FormControl
                                    as="textarea"
                                    value={event.comment ? event.comment : ""}
                                    readOnly={true}
                                />
                            </InputGroup>
                        </Card>
                    </Card.Body>
                </div>
            </Collapse>
        </Card>
    );
};

export const AdminAnalyticsEventLibraryItem = React.memo(
    AdminAnalyticsEventLibraryItemImplementation
);
